/*!
 * VERSION: 1.19.1
 * DATE: 2017-01-17
 * UPDATES AND DOCS AT: http://greensock.com
 *
 * @license Copyright (c) 2008-2017, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 *
 * @author: Jack Doyle, jack@greensock.com
 */
require('gsap/TweenLite');
// require('gsap/TweenMax');
// require('gsap/TimelineLite');
// require('gsap/TimelineMax');

require('gsap/EasePack');

// require('gsap/AttrPlugin');
// require('gsap/BezierPlugin');
require('gsap/CSSPlugin');
// require('gsap/CSSRulePlugin');
// require('gsap/ColorPropsPlugin');
// require('gsap/DirectionalRotationPlugin');
// require('gsap/EaselPluginPlugin');
// require('gsap/EndArrayPlugin');
// require('gsap/ModifiersPlugin');
// require('gsap/RaphaelPlugin');
// require('gsap/RoundPropsPlugin');
// require('gsap/ScrollToPlugin');
// require('gsap/TextPlugin');
